import React from 'react';
import {connect} from 'react-redux';
import {Grid, Image} from 'semantic-ui-react';

import RocketImg from '../../assets/auth/rocket.svg';
import Button from '../../components/forms/button';

export class PaymentSucessfulPage extends React.Component {
	onClickButton = (e) => {
		this.props.history.push('/dashboard/emails/settings/general'); // TODO - remove static url and use `page` props.param
	}

	render () {
		return (
			<Grid centered stackable className='with-padding'>
				<Grid.Row>
					<Grid.Column>
						<h2 className='center'>Welcome!</h2>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<Image src={ RocketImg } className='center' />
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<h4 className='center'>
							Visit settings page and configure your abandoned cart emails.
						</h4>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<Button primary fluid size='big' onClick={ this.onClickButton }>Continue Setup</Button>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.callbackPaymentReducer.meta
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
	};
}

export default connect( mapsStateToProps, mapsDispatchToProps )(PaymentSucessfulPage);



// WEBPACK FOOTER //
// ./src/containers/callback-payment-page/payment-successful-page.js